import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { MdDashboard } from "react-icons/md";
import { FaUser, FaMoneyCheck } from "react-icons/fa";
import { HiMegaphone } from "react-icons/hi2";
import { IoCalendar, IoSettings } from "react-icons/io5";
import { SiGoogletasks, SiReadthedocs } from "react-icons/si";
import { IoMdInformationCircle } from "react-icons/io";
import { BiSolidCoinStack } from "react-icons/bi";
import { Sidebar } from "flowbite-react";

const SidebarComponent = ({ isSidebarOpen, toggleSidebar }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { logout, user, role, position, firstName } = useAuth();
  const navigate = useNavigate();

  const handleLinkClick = (path) => {
    navigate(path);
    toggleSidebar();
    setIsDropdownOpen(false);
  };

  return (
    <div className="h-full bg-white dark:bg-gray-800 border-gray-700">
      <Sidebar
        open={isSidebarOpen}
        className=''
        onClose={toggleSidebar}
        aria-label="Sidebar with content separator example"
        style={{ borderColor: "rgba(0, 0, 0, 0.25)" }}
        theme={{
          "root": {
            "base": "h-full",
            "collapsed": {
              "on": "w-16",
              "off": "w-64"
            },
            "inner": "h-full overflow-y-auto overflow-x-hidden bg-white dark:bg-gray-800 px-3 py-4"
          }
        }}
      >
        <Sidebar.Items>
          <Sidebar.ItemGroup>
            <Sidebar.Item className="pt-5" icon={MdDashboard} onClick={() => handleLinkClick('/user/dashboard')}>
              Dashboard
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={FaUser} onClick={() => handleLinkClick('/user/profile')}>
              Profile
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={HiMegaphone} onClick={() => handleLinkClick('/user/announcements')}>
              Announcements
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('/user/attendance-monitoring')}>
              Attendance
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={SiGoogletasks} onClick={() => handleLinkClick('/user/todo')}>
              To Do
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={SiReadthedocs} onClick={() => handleLinkClick('/user/resources')}>
              Resources
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoSettings} onClick={() => handleLinkClick('/user/settings')}>
              Settings
            </Sidebar.Item>
            <Sidebar.Item className="pt-5" icon={IoMdInformationCircle} onClick={() => handleLinkClick('/user/about')}>
              About
            </Sidebar.Item>
          </Sidebar.ItemGroup>

          <Sidebar.ItemGroup>
          {(role === 'IT Admin' || role === 'Admin') && (
              <Sidebar.Item className="pt-5" icon={BiSolidCoinStack} onClick={() => handleLinkClick('/sysdev/dashboard')}>
                System Dev
              </Sidebar.Item>
            )}
            {(role === 'Assets Admin' || role === 'IT Admin' || role === 'Admin') && (
              <Sidebar.Item className="pt-5" icon={BiSolidCoinStack} onClick={() => handleLinkClick('/assets/dashboard')}>
                Inventory System
              </Sidebar.Item>
            )}
            {(role === 'Payroll Admin' || role === 'IT Admin' || role === 'Admin') && (
              <Sidebar.Item className="pt-5" icon={FaMoneyCheck} onClick={() => handleLinkClick('/payroll/payroll-employees')}>
                Payroll Management
              </Sidebar.Item>
            )}
            {(role === 'HR Admin' || role === 'IT Admin' || role === 'Admin') && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('hr-dashboard')}>
                HR Management
              </Sidebar.Item>
            )}
             {(position === 'Finance & Admin Manager/CFO' || role === 'IT Admin' ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Subic - FAD
              </Sidebar.Item>
            )}
            {(position === 'Sales Manager' || role === 'IT Admin' ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Subic - Sales
              </Sidebar.Item>
            )}
            {(position === 'Manila - Branch Manager' || role === 'IT Admin'  ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Manila
              </Sidebar.Item>
            )}
            {(position === 'Cebu - Branch Manager' || role === 'IT Admin' ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Cebu
              </Sidebar.Item>
            )}
            {(position === 'Southern Region Manager' || role === 'IT Admin' ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Davao
              </Sidebar.Item>
            )}
              {(firstName=== 'Rolan Jayson' || role === 'IT Admin' ) && (
              <Sidebar.Item className="pt-5" icon={IoCalendar} onClick={() => handleLinkClick('department')}>
                Palawan 
              </Sidebar.Item>
            )}

          </Sidebar.ItemGroup>

        </Sidebar.Items>
      </Sidebar>
    </div>
  );
};

export default SidebarComponent;
